import { render } from "./NotificationCategory.vue?vue&type=template&id=32cf07b2"
import script from "./NotificationCategory.vue?vue&type=script&lang=js"
export * from "./NotificationCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__